// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import CollapseAction from '../../../components/actions/CollapseAction';
import ExpandAction from '../../../components/actions/ExpandAction';
import OrderTypeFilterAction from '../../../components/actions/OrderTypeFilterAction';
import Separator from '../../../components/Separator';
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  displayRowMenu: Boolean,
  displayMenu: Boolean,
  setCollapseLoading?: (isLoading: boolean) => void,
};

const ActionsOrganizerOrders = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportODataAction,
    RefreshAction,
    SaveViewAction,
    MultiSortAction,
    currentItem,
    grid,
    getGlobalDisabledState,
    onFiltersChanged,
    groups,
    loading,
    filters,
    saveStatus,
    onGroupCollapsedChanged,
    clearInternalFilters,
    displayRowMenu,
    displayMenu,
    setCollapseLoading,
  } = props;

  const columnGroupActionsDisabled =
    getGlobalDisabledState() || loading || (groups && !groups.length);

  const allowExpandAction =
    !grid ||
    (grid.selection.row >= 0 && grid.rows[grid.selection.row].isCollapsed) ||
    (grid.selection.row < 0 && grid.rows.some(row => row.isCollapsed));

  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            <ExportODataAction />
          </ActionsColumn>

          <ActionsColumn>
            <CopyAction />
            <ColumnsAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <OrderTypeFilterAction
              disabled={loading}
              onClick={onFiltersChanged}
              filters={filters}
              filterType="OrderType"
              saveStatus={saveStatus}
            />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <CollapseAction
              disabled={loading || allowExpandAction}
              grid={grid}
              onGroupCollapsedChanged={onGroupCollapsedChanged}
              currentItem={currentItem}
              setCollapseLoading={setCollapseLoading}
            />
            <ExpandAction
              disabled={columnGroupActionsDisabled || !allowExpandAction}
              onGroupCollapsedChanged={onGroupCollapsedChanged}
              grid={grid}
              setCollapseLoading={setCollapseLoading}
            />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <SaveViewAction filters={filters} grid={grid} />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
          </ActionsColumn>

          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        {displayRowMenu &&
          <div className='actions-menu-top-section'>
            <div style={{ fontWeight: 'bold', color: 'black' }}>{currentItem && currentItem.Desc}</div>
          </div>
        }
        {displayRowMenu &&
          <div className='action-menu-items'>
            <ActionsColumn>
              <table>
                <tbody>
                  <tr>
                    <td><CopyAction /></td>
                  </tr>
                </tbody>
              </table>
            </ActionsColumn>
          </div>
        }
        {displayMenu &&
          <div className='action-menu-items'>
            <ActionsColumn>
              <table>
                <tbody>
                  <tr>
                    <td><ExportODataAction /></td>
                  </tr>
                  <tr>
                    <td><SaveViewAction filters={filters} grid={grid} /></td>
                  </tr>
                </tbody>
              </table>
            </ActionsColumn>
          </div>
        }
      </MobileView>
    </>
  );
};

export default ActionsOrganizerOrders;
